import * as React from 'react'

import { observer } from 'mobx-react'

import centsToDecimal from 'modules/core/lib/formatCents'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  maxWeeklyHoursInCents?: number
}

const MaxWeeklyHours = ({ maxWeeklyHoursInCents }: Props) => {
  const maxWeeklyHours = maxWeeklyHoursInCents ? centsToDecimal(maxWeeklyHoursInCents) : undefined
  return (
    <Item
      id="maximum_weekly_hours"
      title={i18n.t('contract_versions.time.maximum_weekly_hours.title')}
      description={maxWeeklyHours?.toString()}
    />
  )
}

export default observer(MaxWeeklyHours)
